import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-6",
  "use": "menu-6-usage",
  "viewBox": "0 0 36.75 42",
  "content": "<symbol viewBox=\"0 0 36.75 42\" id=\"menu-6\"><title>资源 10</title><g id=\"menu-6_图层_2\" data-name=\"图层 2\"><g id=\"menu-6_图层_1-2\" data-name=\"图层 1\"><path d=\"M0,2.62A2.63,2.63,0,0,1,2.64,0H34.11a2.63,2.63,0,0,1,2.64,2.62V39.37A2.63,2.63,0,0,1,34.11,42H2.64A2.63,2.63,0,0,1,0,39.38H0ZM7.87,9.19A1.33,1.33,0,0,0,9.19,10.5H27.56a1.31,1.31,0,1,0,0-2.62H9.19A1.32,1.32,0,0,0,7.87,9.19Zm0,7.87a1.31,1.31,0,0,0,1.29,1.31h7.93a1.29,1.29,0,0,0,1.29-1.31,1.31,1.31,0,0,0-1.29-1.31H9.16A1.29,1.29,0,0,0,7.87,17Zm0,7.87a1.32,1.32,0,0,0,1.29,1.31H22.34a1.31,1.31,0,0,0,0-2.62H9.16A1.31,1.31,0,0,0,7.87,24.94Zm0,7.87a1.33,1.33,0,0,0,1.31,1.31H27.56a1.31,1.31,0,0,0,0-2.62H9.19A1.32,1.32,0,0,0,7.87,32.81Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-6.svg
// module id = 3tQT
// module chunks = 264